// 数据库操作未切换之前 PadInfo 仍然使用 docs_offline 旧版数据结构
import { UserInfo, PadInfo } from '@tencent/docs_offline';
import {
    DOCUMENT_TYPE,
    DOCUMENT_TYPE_DESC,
    DOCUMENT_STATUS,
} from '@tencent/ark-model';
import { IClientVars } from '@src/slide/domain/slide-app/core/interfaces/client-vars.interface';
import { IOfflineEditContext } from '../core/interfaces/offline-edit-context.interace';
import { DVER } from '../constants';

export enum PadIdType {
    GLOBAL = 'globalPadId',
    SECRET = 'secretId'
}

export function buildPadInfo(clientVars: IClientVars, context: IOfflineEditContext): PadInfo {
    const time = Date.now() / 1000;
    const { uid, uin, folder } = context;
    const user = new UserInfo({ uid, uin });
    const defaultInfo = new PadInfo(user);
    const secretId = clientVars?.collab_client_vars?.client?.upid ?? '';
    const { domainId = '', globalPadId = '', title = '', padId = '', localPadId = '', padStatus } = clientVars;

    return {
        ...defaultInfo,
        globalPadId,
        uid: context.uid,
        key: context.uid + globalPadId,
        // PadInfo 中字段类型后续会替换成 ark-model 中字段值
        type: DOCUMENT_TYPE.slide as any,
        doc_type: DOCUMENT_TYPE.slide as any,
        doc_type_desc: DOCUMENT_TYPE_DESC.slide as any,
        status: padStatus || DOCUMENT_STATUS.normal as any,
        dver: clientVars?.collab_client_vars?.dver ?? DVER,
        pad_id: padId || localPadId,
        domain_id: domainId,
        secretId,
        title,
        folder,
        creator: uid,
        creator_domain: domainId,
        isOfflineCache: true,   // 离线缓存标记
        create_ts: time,
        last_modify_ts: time,
        last_browse_ts: time,
        lastSyncTime: time,
        isRencent: true,
        doc_url: `//${window.hostname}/slide/${secretId}`,
    };
}

export function syncPadInfo(curPadInfo: PadInfo, clientVars: IClientVars): PadInfo {
    const newPadInfo = curPadInfo;
    const { collab_client_vars: collabClientVars, domainId = '', padId = '', localPadId = '' } = clientVars;
    newPadInfo.isOfflineCache = true;
    newPadInfo.dver = collabClientVars?.dver ?? DVER;
    newPadInfo.domain_id = domainId;
    newPadInfo.pad_id = padId || localPadId;
    newPadInfo.status = clientVars.padStatus as any || curPadInfo.status;

    return newPadInfo;
}
